import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../api.js'
import { qk } from './keys.js'

export const mcpQuery = queryOptions({
  queryKey: qk.mcp,
  queryFn: ({ signal }) => api('/mcp', { signal }),
  staleTime: 60_000,
})

export function useMcp() {
  return useQuery(mcpQuery)
}

/** Starts the Integrator MCP sign-in: the browser leaves for the sign-in page and returns to this one. */
export function useConnectMcp() {
  return useMutation({
    mutationFn: () =>
      api('/mcp/connect', { method: 'POST', body: { next: window.location.pathname + window.location.search } }),
    onSuccess: ({ url }) => window.location.assign(url),
  })
}

export function useDisconnectMcp() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => api('/mcp', { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: qk.mcp }),
  })
}
